import api from "./api";
import { request } from "api/apiSaga";
import { call, takeLatest } from "redux-saga/effects";
import { AnyAction } from "redux";
import types from "./types";

function* fetch(action: AnyAction) {
    yield call(request, api.fetch, action);
}

function* get(action: AnyAction) {
    yield call(request, api.get, action);
}

function* modulesFetch(action: AnyAction) {
    yield call(request, api.modules.fetch, action);
}

function* datatransGateway(action: AnyAction) {
    yield call(request, api.modules.datatrans.gateway, action);
}

function* gastroPayConfigure(action: AnyAction) {
    yield call(request, api.modules.gastroPay.configure, action, "post");
}
function* gastroPayGateway(action: AnyAction) {
    yield call(request, api.modules.gastroPay.gateway, action);
}
function* gastroPayRemove(action: AnyAction) {
    yield call(request, api.modules.gastroPay.remove, action, "delete");
}
function* gastroPayUpdate(action: AnyAction) {
    yield call(request, api.modules.gastroPay.update, action, "put");
}

export default function* saga() {
    yield takeLatest(types.FETCH_REQUEST, fetch);
    yield takeLatest(types.GET_REQUEST, get);

    yield takeLatest(types.MODULES_FETCH_REQUEST, modulesFetch);

    yield takeLatest(types.DATATRANS_GATEWAY_REQUEST, datatransGateway);

    yield takeLatest(types.GASTROPAY_CONFIGURE_REQUEST, gastroPayConfigure);
    yield takeLatest(types.GASTROPAY_GATEWAY_REQUEST, gastroPayGateway);
    yield takeLatest(types.GASTROPAY_REMOVE_REQUEST, gastroPayRemove);
    yield takeLatest(types.GASTROPAY_UPDATE_REQUEST, gastroPayUpdate);
}
